import { useContext, useState } from "react";
import ImgWrapper from "../ImgWrapper";
import Spacer from "../Spacer";
import chevronDownWhite from "assets/icons/chevronDownWhite.svg";
import { NavLink, useLocation } from "react-router-dom";
import AiIcon from "assets/icons/ai-new-icon.svg";
import DmIcon from "assets/icons/dm-Icon.svg";
import CommentIcon from "assets/icons/commentIcon.svg";
import AccountIcon from "assets/icons/analyticAccountIcon.svg";
import NaraIcon from "assets/icons/nara-logo.png";
import UserGroup from "assets/icons/userGroupIcon-light.svg";
import OfficeIcon from "assets/icons/officeIcon-light.svg";
import HomeIcon from "assets/icons/homeIcon.svg";
import {
  ArrowWrapper,
  BottomSection,
  Overlay,
  Wrapper,
  Menu,
  WorkspaceContainer,
  WorkspaceMenu,
  BrandSwitcher,
} from "./SidebarStyle";
import DropdownList from "./DropdownList";
import { connect } from "react-redux";
import { getAiBrandInfo, getBrand, getMember, setBrandDetails } from "api";
import { useEffect } from "react";
import useSwitchWorkspace from "hooks/useSwitchWorkspace";
import { useCallback } from "react";
import NewTag from "./NewTag";
import plannerIcon from "assets/icons/planner-icon.svg";
import SuggestFeature from "assets/icons/suggest_feature.svg";
import RequestFeature from "views/requestFeature.jsx/RequestFeature";
import { colorArray } from "utils/utils";
import ChevronRightIcon from "icons/ChevronRight";
import AutomationIcon from "assets/icons/automation_icon.svg";
import mediaWhite from "assets/icons/media-white.svg";
import UserIconFilled from "assets/icons/UserIconFilled.svg";
import { MediaLibraryContext } from "contexts/MediaLibraryContext";
import { socialIcons } from "constants/post";

const Sidebar = ({
  user,
  user_accounts,
  active_account,
  brands,
  brand,
  setBrandDetails,
  dms_badge,
  comments_badge,
}) => {
  const { pathname } = useLocation();
  const { setShowMediaLibrary, showMediaLibrary } =
    useContext(MediaLibraryContext);
  const [showDropdownList, setShowDropdownList] = useState({
    brands: false,
    workspaces: false,
  });
  const [showFeatureRequest, setShowFeatureRequest] = useState(false);

  const { saveAccountId } = useSwitchWorkspace(
    active_account,
    user_accounts,
    setBrandDetails,
    user
  );

  const handleSelectBrand = useCallback(
    (brand) => {
      setBrandDetails(brand);
      getBrand(brand?.id);
      getMember(); // set member access
      getAiBrandInfo(); // update AI brand info
    },
    [setBrandDetails]
  );

  const hideSidebar = () => {
    document.querySelector(".sidebar").classList.remove("open");
    document.querySelector(".sidebar-overlay").classList.remove("open");
  };

  useEffect(() => {
    // set active brand to the first brand when user has no active brand selected
    if (!brand && brands?.length > 0) {
      handleSelectBrand(brands[0]);
      // else if current brand is locked/inactive, switch to an active brand
    } else if (brand && brand?.status !== 1) {
      const activeBrand = brands.find((brand) => brand.status === 1);
      handleSelectBrand(activeBrand);
    }
  }, [brand, brands, handleSelectBrand]);

  useEffect(() => {
    hideSidebar();
  }, [pathname]);

  return (
    <>
      <Overlay className="sidebar-overlay" onClick={hideSidebar}></Overlay>

      <Wrapper className="sidebar">
        <BrandSwitcher className="">
          <div className="flexRow alignCenter brand-header">
            <ImgWrapper size="4">
              {brand?.avatar ? (
                <img src={brand?.avatar} alt="user" />
              ) : (
                <span className="colorWhite textSmall upperCase">
                  {brand?.name?.charAt(0)}
                  {brand?.name?.charAt(1)}
                </span>
              )}
            </ImgWrapper>
            <div className="">
              <p className="brand">Brand</p>
              <p className="brand-name textNoWrap">{brand?.name}</p>
            </div>
          </div>
          {brands?.length > 1 && (
            <div
              className="switch-button "
              onClick={() => {
                if (brands?.length > 1) {
                  setShowDropdownList((prev) => ({
                    ...prev,
                    brands: !prev.brands,
                  }));
                }
              }}
            >
              <img src={chevronDownWhite} className="scroll-prev" alt="" />
            </div>
          )}
        </BrandSwitcher>
        {showDropdownList.brands && (
          <DropdownList
            setShowDropdownList={setShowDropdownList}
            title="List of Brands"
            top
            list={brands}
            defaultSelected={brand}
            callback={handleSelectBrand}
            lastListElementRef={null}
            type="brand"
          />
        )}

        <div className="top-section">
          <Menu>
            <ul>
              <li className="nav-item">
                <NavLink to="/dashboard/home">
                  <div className="linkGroup">
                    <img src={HomeIcon} alt="home" className="icon" />
                    Home
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink to="/dashboard/posts">
                  <div className="linkGroup">
                    <img src={plannerIcon} alt="drafts" className="icon" />
                    Post Planner
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink to={"/dashboard/nara/home"}>
                  <div className="linkGroup">
                    <img src={NaraIcon} alt="home" className="icon" />
                    Nara AI chat
                    <NewTag
                      text="Beta"
                      background="var(--secondary)"
                      color="#fff"
                    />
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink to="/dashboard/ig-grid-planner">
                  <div className="linkGroup">
                    <img
                      src={socialIcons.circle.instagram}
                      alt="drafts"
                      className="icon"
                    />
                    IG Grid Planner
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink to="/dashboard/ai-assistant">
                  <div className="linkGroup">
                    <img src={AiIcon} alt="ai" className="icon" />
                    AI assistant
                  </div>
                </NavLink>
              </li>
              <li>
                <button
                  onClick={() => setShowMediaLibrary(true)}
                  className={`${
                    showMediaLibrary ? "active" : ""
                  } fullWidth linkGroupWrapper`}
                  type="button"
                >
                  <div className="linkGroup">
                    <img src={mediaWhite} alt="media" className="icon" />
                    Media library
                  </div>
                </button>
              </li>
              <li>
                <NavLink to="/dashboard/direct-messages">
                  <div className="linkGroup">
                    <div className="image-with-dot">
                      {dms_badge && <div className="dot"></div>}
                      <img
                        src={DmIcon}
                        alt="direct messages"
                        className="icon"
                      />
                    </div>
                    <span className="flexRow">Direct messages</span>
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink to="/dashboard/comments">
                  <div className="linkGroup">
                    <div className="image-with-dot">
                      {comments_badge && <div className="dot"></div>}
                      <img src={CommentIcon} alt="comments" className="icon" />
                    </div>
                    <span className="flexRow">Post comments</span>
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink to="/dashboard/automation">
                  <div className="linkGroup">
                    <div className="image-with-dot">
                      {comments_badge && <div className="dot"></div>}
                      <img
                        src={AutomationIcon}
                        alt="comments"
                        className="icon"
                      />
                    </div>
                    <span className="flexRow">Automations</span>

                    {/* <NewTag
                      text="New"
                      background="var(--secondary)"
                      color="#fff"
                    /> */}
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink to="/dashboard/crm">
                  <div className="linkGroup alignCenter">
                    <img
                      src={UserIconFilled}
                      alt="contacts"
                      className="icon alignCenter"
                    />
                    <span className="flexRow">Contacts</span>

                    <NewTag
                      text="Beta"
                      background="var(--secondary)"
                      color="#fff"
                    />
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink to="/dashboard/analytics">
                  <div className="linkGroup">
                    <img src={AccountIcon} alt="analytics" className="icon" />
                    Analytics
                  </div>
                </NavLink>
              </li>
            </ul>
          </Menu>
        </div>

        <BottomSection>
          <WorkspaceMenu>
            <ul>
              <li className="menu-list">
                <NavLink to="/dashboard/brands">
                  <div className="linkGroup">
                    <img src={OfficeIcon} alt="brands" className="icon" />
                    Manage brands
                  </div>
                </NavLink>
              </li>
              <li className="menu-list">
                <NavLink to="/dashboard/team-members">
                  <div className="linkGroup team-tour">
                    <img src={UserGroup} alt="team" className="icon" />
                    Manage team
                  </div>
                </NavLink>
              </li>
              <li className="menu-list">
                <button
                  onClick={() => setShowFeatureRequest(true)}
                  style={{ width: "100%" }}
                >
                  <div className="linkGroup team-tour">
                    <img src={SuggestFeature} alt="team" className="icon" />
                    Suggest a feature
                  </div>
                </button>
              </li>
            </ul>
          </WorkspaceMenu>

          <Spacer y={1.3} />

          {user_accounts?.length > 0 && (
            <WorkspaceContainer
              id="workspace-target-click" // for guided tour
            >
              <div className="workspaces">
                <Spacer y={1.6} />
                <div className="workspace_name">Workspace</div>
                <Spacer y={0.8} />
                <div className="flexRow">
                  {user_accounts?.map((acc, idx) => (
                    <div className="workspace_acc" key={idx}>
                      <ImgWrapper
                        size={3.2}
                        imgHeight={"100%"}
                        className="imgWrapper"
                        bg={colorArray[idx]}
                      >
                        {acc?.avatar ? (
                          <img src={acc.avatar} alt="brand" />
                        ) : (
                          acc.name?.slice(0, 1)
                        )}
                      </ImgWrapper>
                    </div>
                  ))}
                </div>
              </div>
              <ArrowWrapper
                onClick={() =>
                  setShowDropdownList((prev) => ({
                    ...prev,
                    workspaces: !prev.workspaces,
                  }))
                }
              >
                <ChevronRightIcon color="#fff" />
              </ArrowWrapper>

              {showDropdownList.workspaces && (
                <DropdownList
                  setShowDropdownList={setShowDropdownList}
                  title="List of Workspaces"
                  list={user_accounts}
                  defaultSelected={active_account}
                  callback={saveAccountId}
                  isLoading={false}
                  lastListElementRef={null}
                  user={user}
                  user_accounts={user_accounts}
                  type="account"
                />
              )}
            </WorkspaceContainer>
          )}

          <Spacer y={2.4} />
        </BottomSection>
      </Wrapper>

      {showFeatureRequest && (
        <RequestFeature setShowFeatureRequest={setShowFeatureRequest} />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    brand: state.brand,
    brands: state.brands,
    user: state.user,
    user_accounts: state.user_accounts,
    active_account: state.active_account,
    dms_badge: state.dms_badge,
    comments_badge: state.comments_badge,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setBrandDetails: (data) => dispatch(setBrandDetails(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
